import { apiUrl, exportData, getList, getSingleRecord } from './apiUtils';
import type { ApiListParamsWithUnderscores, ApiExportParams } from '../types/api/listParams';
import type { ListApiResponse } from '../types/apiResponse';
import type { EmailRequestModel } from '../types/api/emails';

const baseUrl = apiUrl + '/emails/';

export function getEmails(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<EmailRequestModel>> {
  return getList<EmailRequestModel>(`${baseUrl}search`, params);
}

export function getEmailById(id: string): Promise<EmailRequestModel> {
  return getSingleRecord<EmailRequestModel>(baseUrl, id);
}

export function exportEmailData(params: ApiExportParams): Promise<void> {
  return exportData(`${apiUrl}/export/emails/search`, 'creationDate', params);
}

export function resendEmail(id: string): Promise<{ id: string }> {
  return getSingleRecord<{ id: string }>(`${baseUrl}resend/`, id);
}
